import { Component, Inject, OnInit } from '@angular/core';
import { ManagedClinicService } from '../managed-clinic.service';
import { ClinicRoom } from '../managed-clinic.model';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CommonService } from '@app/services/common.service';

@Component({
  selector: 'app-add-room',
  templateUrl: './add-room.component.html',
  styleUrls: ['./add-room.component.scss'],
})
export class AddRoomComponent implements OnInit {
  roomsArray: Array<{ name: string; weight: number }> = [];
  sortedData: ClinicRoom[] = [];
  deletionArray: Array<string> = [];
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public dialogData: { clinic_id: string; list: ClinicRoom[] },
    private managedClinicServices: ManagedClinicService,
    private commonService: CommonService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<AddRoomComponent>
  ) {
    this.sortedData = [...this.dialogData?.list].sort(
      (a, b) => b.weight - a.weight
    );
    this.roomsArray = [
      {
        name: '',
        weight: this.sortedData[0]?.weight ? this.sortedData[0]?.weight + 1 : 1,
      },
    ];
  }
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }
  selectRoomForDeletion(event: MatCheckboxChange, value: string) {
    event.checked
      ? this.deletionArray.push(value)
      : this.deletionArray.slice(this.deletionArray.indexOf(value), 1);
  }
  deleteRooms() {
    const selectedList: string[] = [];
    this.managedClinicServices
      .deleteRoom(this.dialogData?.clinic_id, this.deletionArray.slice())
      .subscribe({
        next: (res) => (res?.status ? this.dialogRef.close(true) : ''),
      });
  }

  removeRoom(index: number) {
    this.roomsArray.splice(index, 1);
  }
  verifyInputData(index: number) {
    const name = this.roomsArray[index].name ? this.roomsArray[index].name : '';
    const weight = this.roomsArray[index].weight
      ? this.roomsArray[index].weight
      : '';
    const elementId: string = '#row_' + index.toString();
    if (name.trim().length == 0) {
      this.assignErrorClassTorRow(elementId);
      return;
    }
    if (Number(weight) < 0 || !Number.isInteger(Number(weight))) {
      this.assignErrorClassTorRow(elementId);
      return;
    }
    let isDuplicate: boolean = false;
    this.roomsArray.map((room, i) => {
      if (room?.name?.toLowerCase() == name.toLowerCase() && i != index) {
        this.assignErrorClassTorRow(elementId);
        isDuplicate = true;
        return;
      }
    });
    this.dialogData?.list.map((room) => {
      if (room?.name?.toLowerCase() == name.toLowerCase()) {
        this.assignErrorClassTorRow(elementId);
        isDuplicate = true;
        return;
      }
    });
    if (isDuplicate) {
      this.assignErrorClassTorRow(elementId);
      return;
    }
    this.removeErrorClassTorRow(elementId);
  }

  assignErrorClassTorRow(id: string) {
    (document.querySelector(id) as HTMLElement).classList.add('error-row');
  }
  removeErrorClassTorRow(id: string) {
    (document.querySelector(id) as HTMLElement).classList.remove('error-row');
  }
  addNewLine() {
    this.roomsArray.unshift({
      name: '',
      weight: this.roomsArray.length
        ? this.roomsArray[0]?.weight + 1
        : this.sortedData[0]?.weight + 1,
    });
  }

  saveRoom() {
    let invalid: boolean = false;
    const roomsNameArray = [
      ...this.roomsArray.map((room) => room.name.toLowerCase()),
      ...this.dialogData?.list.map((room) => room.name.toLowerCase()),
    ];

    this.roomsArray.map((room, index) => {
      if (
        room?.name?.toLowerCase() == '' ||
        roomsNameArray.indexOf(room?.name.toLowerCase()) != index ||
        room?.weight < 0 ||
        !Number.isInteger(Number(room?.weight))
      ) {
        this.assignErrorClassTorRow('#row_' + index.toString());
        invalid = true;
        return;
      } else {
        this.removeErrorClassTorRow('#row_' + index.toString());
        room.weight = Number(room.weight);
      }
    });
    if (invalid) {
      this.commonService.FailedAlertDialog({
        dialog: this.dialog,
        message: `Please enter room name`,
      });
      return;
    }
    if (this.roomsArray.length == 0) {
      this.close();
    }

    this.managedClinicServices
      .addRoom(this.dialogData?.clinic_id, this.roomsArray)
      .subscribe({
        next: (res) => (res?.status ? this.dialogRef.close(true) : ''),
      });
  }
  close() {
    this.dialogRef.close(false);
  }
}
